import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import useStore from '@/utils/store/common';
import PageHeader from '@/components/common/PageHeader/PageHeader.vue';
import { UserRole } from '@/store/modules/userRoles/types';
import Left from './components/Left/Left.vue';
import Right from './components/Right/Right.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VUserRole',
  setup(__props) {


const store = useStore();

const getSelected = computed(() => store.getters['userRoles/getSelected']);
const getUserRolesList = computed(() => store.getters['userRoles/getUserRolesList']);

function updateSelected(event: UserRole | undefined) {
  if (event && event.id !== getSelected.value?.id) {
    const role = {
      ...event,
      permissions: store.getters['userRoles/getPermissionsFeaturesOfCurrentlySelectedUserRole']
    };
    store.dispatch('userRoles/fetchPermissionsOfRole', event.id).then(() => store.dispatch('userRoles/setSelected', role));
  }
}

// When changing page, ensure the first is selected.
watch(
  () => store.getters['userRoles/getUserRolesListState'],
  () => {
    if (store.getters['userRoles/getUserRolesListState'].fetched.userRolesList) {
      updateSelected(getUserRolesList.value[0]);
    }
  },
  {
    deep: true,
    immediate: true
  }
);

return { __sfc: true,store, getSelected, getUserRolesList, updateSelected, PageHeader, Left, Right }
}

})